// extracted by mini-css-extract-plugin
export default {"largeScreenWidth":"70","mediumScreenWidth":"38","projectDetailsWidth":"46","techStack":"TechStack_techStack__0bFoJ"};